module.exports = __webpack_public_path__ + "static/media/gloves.1a98f3ac.jpg";